import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
export const ViewSectionHeader = ({ className, children }) => {
    return _jsx("div", { className: cn('mb-6', className), children: children });
};
export const ViewSectionContent = ({ className, children }) => {
    return _jsx("div", { className: cn(className), children: children });
};
export const ViewSectionTitle = ({ className, children }) => {
    return (_jsx("h2", { className: cn('scroll-m-20 text-xl font-semibold text-heading tracking-wide dark:text-white border-b-4 border-b-gray-200 pb-3', className), children: children }));
};
export const ViewSection = ({ children, className }) => {
    return _jsx("div", { className: cn('', className), children: children });
};
